import { render, staticRenderFns } from "./giveVipDialog.vue?vue&type=template&id=279d8252&"
import script from "./giveVipDialog.vue?vue&type=script&lang=js&"
export * from "./giveVipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports